import { Component, h } from 'preact'
import styles from './video.module.css'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

interface Props {
  id?: string
  text?: string
  gaTrackingId?: string
}

class Video extends Component<Props> {
  ludo?: any
  ludoInstance?: any
  ludoMount?: HTMLDivElement

  async componentDidMount() {
    if (this.props.id) {
      const id = this.extractIdFromSmartUrl(this.props.id)
      await this.instanciateLudo(id)
    }
  }

  extractIdFromSmartUrl = (id) => {
    if (id.indexOf('klipp:') > -1) {
      return id.substr(id.lastIndexOf('/') + 1, id.length)
    }
    return id
  }

  requireLudo = () =>
    new Promise((resolve, reject) => {
      if (this.ludo) {
        resolve(this.ludo)
      } else {
        const require = (window as any).requirejs
        require(['ludo'], (ludo: any) => {
          if (ludo) {
            this.ludo = ludo
            resolve(this.ludo)
          } else {
            reject(new Error('Failed to require Ludo'))
          }
        })
      }
    })

  getOptions = () => {
    const trackingId = this.getTrackingId()
    return {
      chromecast: {
        enabled: false,
      },
      analytics: {
        ga: {
          trackingId,
        },
      },
    }
  }

  getTrackingId = () => {
    return this.ludoMount.closest(tag).getAttribute('data-ga-property-id')
  }

  instanciateLudo = async (id: string) => {
    // eslint-disable-next-line promise/always-return
    return this.requireLudo().then((ludo: any) => {
      this.ludoInstance = ludo(this.ludoMount, id, this.getOptions())
    })
  }

  render() {
    return (
      <div
        className={styles.video}
        ref={(el) => {
          this.ludoMount = el
        }}
      />
    )
  }
}

export { Video }
